

window.addEventListener("load", function () {
     
});
